import { PropsWithChildren } from 'react';

type ProductDetailsSectionHeaderProps = PropsWithChildren & {
  icon: JSX.Element;
};

export const ProductDetailsSectionHeader: React.FC<
  ProductDetailsSectionHeaderProps
> = ({ icon, children }) => (
  // eslint-disable-next-line tailwindcss/no-arbitrary-value
  <div className="flex gap-[10px] py-spacing/padding/x-xs text-text/accent items-center">
    {icon}
    {/* Section title (Offers/Highlights/Benefits/Fees/Eligibility) as an <h2> for
        semantic heading structure — the page <h1> is the product title (CMS-1868). */}
    <h2 className="mhg-alpha-title-1 m-0">{children}</h2>
  </div>
);
